// extracted by mini-css-extract-plugin
export default {"privacy_top":"Privacy_privacy_top__igvsj","download_btn":"Privacy_download_btn__8YeEv"};